import { render, staticRenderFns } from "./MealItemsSelectActions.vue?vue&type=template&id=68570eee"
import script from "./MealItemsSelectActions.vue?vue&type=script&lang=js"
export * from "./MealItemsSelectActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports